package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.STAFF_LOGIN
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class LoginStaffRequestModel(
    val email: String,
    val password: String
) : BaseRequestModel(api = STAFF_LOGIN)
